<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row p-5">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset password.svg" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset Password</h4>
                                    <p>Please enter your new password.</p>
                                </div>
                                <vs-input
                                  id="email"
                                  ref="password"
                                  v-validate="'required|min:8'"
                                  type="password"
                                  name="Password"
                                  icon-no-border
                                  icon="icon icon-lock"
                                  icon-pack="feather"
                                  label-placeholder="Password"
                                  v-model="password"
                                  @keyup.enter="resetPassword"
                                  class="w-full" />
                                  <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
                                  <vs-input
                                    v-validate="'required|confirmed:password|min:8'"
                                    type="password"
                                    name="password_confirmation"
                                    icon-no-border
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Confirm password"
                                    v-model="confirm_password"
                                    data-vv-as="password"
                                    class="w-full pt-3" />
                                  <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-8">
                                    <vs-button type="link" to="/login" class="back-to-login font-semibold w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Login</vs-button>
                                    <vs-button class="w-full sm:w-auto" @click="resetPassword">set password</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";

export default {
  data () {
    return {
      password: '',
      confirm_password: ''
    }
  },
  methods:{
    async resetPassword(){
      try{
        this.$vs.loading()
        await axios.post('account/verify/',{ password: this.password, code: this.$route.query.code })
        await this.$router.push('/login')
        this.$ntSet()
      }catch (error){
        this.$ntSetError(error.data.message)
      }finally {
        this.$vs.loading.close()
      }
    },
    focusField(){
      document.getElementById('email').focus()
    },

  },
  mounted() {
    this.focusField()
  }
}
</script>

<style>
[dir] .vx-row{
  margin: 0 !important;
}
.back-to-login .vs-button-text.vs-button--text{
  color: #5b3cc4 !important;
}
</style>
